module.exports = __webpack_public_path__ + "img/registration-description-image@2x.36131871.png";